import React, { FC } from 'react';
import { Card, CardContent, Skeleton } from '@mui/material';


interface BookingCardSkeletonProps {}

const BookingCardSkeleton: FC<BookingCardSkeletonProps> = () => {
  return (
    <Card data-testid='BookingCardSkeleton'       className="w-full  max-c-md:max-w-[340px]  c-md:h-[227px] h-[480px] !shadow-none c-md:!rounded-s-[16px]  !rounded-[16px]  !overflow-x-hidden border border-solid border-[#e2edf8]">
      <CardContent className="!p-0 flex c-md:flex-row flex-col max-c-md:justify-between">
        <div className="relative c-md:w-[220px] w-full c-md:h-[227px] h-[175px]">
          <Skeleton variant="rectangular" width="100%" height="100%" />
        </div>

        <div className="flex flex-col c-md:p-6 p-4 c-md:flex-1 justify-between">
          <Skeleton variant="rounded" width={80} height={24} className="mb-3" />
          <Skeleton variant="text" width="60%" height={24} className="mb-1" />
          <Skeleton variant="text" width="50%" height={20} className="mb-8" />

          <div className="mt-4 gap-2 pt-4 flex justify-between items-center border-t border-[#d8dcde]">
            <div>
              <Skeleton variant="text" width={120} height={16} />
              <Skeleton variant="text" width={100} height={24} className="mt-1" />
            </div>
            <Skeleton variant="rounded" width={120} height={40} />
          </div>
        </div>
      </CardContent>
    </Card>
  );
};



export default BookingCardSkeleton;
